import { ModalController, LoadingController } from 'ionic-angular';
import { Row, Cell } from "../../../api/index";
import { CalculationService } from "../../calculation/calculation-service";
import { Action } from './action';

export class ActionRowRepeat implements Action {

    constructor(
        protected calculationService: CalculationService,
        protected modalController: ModalController,
        protected loadingController: LoadingController
    ) {}

    trigger(row:Row) : Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            let modal = this.modalController.create('action-row-repeat');
            let loading = this.loadingController.create({
                content: 'Zeilen werden kopiert...'
            });

            modal.onDidDismiss((data) => {
                if (data && data.past && data.repeat) {
                    loading.present();
                }
                
                setTimeout(() => {
                    if (data && data.past && data.repeat) {                
                        let newRows = this.prepareRows(row, data);
                        let rowPromises = [];

                        for (let i = 0; i < newRows.length; i++) {
                            rowPromises.push(this.calculationService.addRow(row.id, row.type, 'below'));
                        }

                        Promise.all(rowPromises)
                            .then((promisedRows:Row[]) => {
                                rowPromises = [];                        
                                for (let j = 0; j < newRows.length; j++) {
                                    for (let c = 0; c < newRows[j].cells.length; c++) {
                                        promisedRows[j].cells[c].value = newRows[j].cells[c].value;
                                        promisedRows[j].cells[c].valueDisplay = newRows[j].cells[c].valueDisplay;
                                    }                                    
                                    rowPromises.push(this.calculationService.editRow(promisedRows[j]));
                                }
                                return Promise.all(rowPromises);
                            }).then(() => {
                                loading.dismiss();
                                resolve(true);
                            });                
                    } else {
                        resolve(false);
                    }
                }, 100);
            });

            modal.present();
        });        
    }

    prepareReferenceDates(row:Row, data) : Date[] {
        let dates = [];
        let referenceDate:Date = this.findReferenceDate(row);

        let day = 15;
        if (data.repeat == 'm1' || data.repeat == 'q') {
            day = 1;
        } else if (data.repeat == 'm28') {
            day = 28;
        }  else if (data.repeat == 'm3') {
            day = 3;
        }

        var months = [0,3,6,9];
        if (data.repeat != 'q') {
            months = [0,1,2,3,4,5,6,7,8,9,10,11];
        }

        // calculate from today's date
        if (data.past == 'no') {
            let currentMonth = (new Date()).getMonth();
            months = months.filter((month) => {
                return month > currentMonth;
            });
        }

        // prepare rows changing dates
        for (let i = 0; i < months.length; i++) {
            let date = new Date(referenceDate.getFullYear(), months[i], day);
            dates.push(date);    
        }

        return dates;
    }

    prepareRows(row:Row, data) : Row[] {
        let rows:Row[] = [];
        let dates = this.prepareReferenceDates(row, data);

        // prepare rows changing dates
        for (let i = 0; i < dates.length; i++) {
            rows.push(this.copyRowWithNewDates(row, dates[i]));    
        }

        return rows;
    }

    isDateCell(cell:Cell) {
        return cell.celltype == 'date' && cell.datatype == 'integer';
    }

    copyRowWithNewDates(row:Row, date:Date) : Row {
        let copiedRow:Row = JSON.parse(JSON.stringify(row));

        for (let i = 0; i < copiedRow.cells.length; i++) {
            if (this.isDateCell(copiedRow.cells[i])) {
                copiedRow.cells[i].value = parseInt((date.getTime() / 1000) + "");
            }
        }

        return copiedRow;
    }

    // returns first date inside the row
    // this might be changed by a parameter if necessary
    findReferenceDate(row:Row) : Date {
        let cells:Cell[] = row.cells;
        let date = new Date();

        for (let cell of cells) {
            if (this.isDateCell(cell)) {
                try {   
                    date = new Date(parseInt(cell.value) * 1000);                   
                } catch(e) {}
                break;
            }
        }

        return date;
    }

}


// WEBPACK FOOTER //
// ./src/services/row-action/action/action-row-repeat.ts